import { CheckValuesType } from "@ssf/memdb-api";
export const TASK_NAMES = {
    addMembers: "addMembers",
    signMemberships: "signMemberships",
    signConstituentMeeting: "signConstituentMeeting",
    constituentMeeting: "constituentMeeting",
    annualReport: "annualReport",
    annualMeeting: "annualMeeting",
    signAnnualMeeting: "signAnnualMeeting",
    classList: "classList",
    electBoard: "electBoard",
    orderGift: "orderGift",
    addPlayers: "addPlayers",
    addPlayersNoClassSize: "addPlayersNoClassSize",
    teamPlayerMembershipsApproved: "teamPlayerMembershipsApproved",
    teamPlayerMembershipsSigned: "teamPlayerMembershipsSigned",
    breakWeeks: "breakWeeks",
    orderGoldGift: "orderGoldGift",
};
export const TASK_STATUS = {
    current: "current",
    pendingApproval: "pendingApproval",
    completed: "completed",
    future: "future",
};
export const getTasks = ({ issues, clubApprovalStatus, registrations, clubId, isStartedCurrentYear, isUnapprovedClub, isPreUnapprovedClub, clubStatus, t, }) => {
    const completedTasks = [];
    const currentTasks = [];
    const pendingApproval = [];
    const futureTasks = [];
    const currentRegistrations = registrations?.filter((registration) => new Date(registration.date).getFullYear() === new Date().getFullYear());
    const unfinishedCount = currentRegistrations?.filter((registration) => !registration.documentid)
        .length || 0;
    const allRegistrationsSigned = registrations &&
        registrations?.length > 0 &&
        registrations?.every((reg) => reg.documentid &&
            new Date(reg.date).getFullYear() === new Date().getFullYear());
    const someRegistrationsSigned = registrations &&
        registrations.length > 0 &&
        registrations.some((reg) => reg.documentid);
    const constituentMeetingStatus = clubApprovalStatus.find((issue) => issue.referenceid === CheckValuesType.ConstituentMeeting);
    const orderedGiftStatus = clubApprovalStatus.find((issue) => issue.referenceid === CheckValuesType.AnnualGift);
    // Handle board election and add members tasks for new clubs
    if (isStartedCurrentYear || constituentMeetingStatus) {
        if (isPreUnapprovedClub) {
            currentTasks.push({
                name: TASK_NAMES.addMembers,
                status: TASK_STATUS.current,
                label: t("addMembers.unfinished"),
                link: t("addMembers.link", { clubId }),
            });
            currentTasks.push({
                name: TASK_NAMES.electBoard,
                status: TASK_STATUS.current,
                label: t("electBoard.unfinished"),
                link: t("electBoard.link", { clubId }),
            });
        }
        else {
            completedTasks.push({
                name: TASK_NAMES.electBoard,
                status: TASK_STATUS.completed,
                label: t("electBoard.finished"),
                link: t("electBoard.link", { clubId }),
            });
        }
    }
    // Handle add members task for old clubs
    if (!isStartedCurrentYear) {
        if (registrations && registrations.length === 0) {
            currentTasks.push({
                name: TASK_NAMES.addMembers,
                status: TASK_STATUS.current,
                label: t("addMembers.unfinished"),
                link: t("addMembers.link", { clubId }),
            });
        }
    }
    // Handle sign memberships task
    const memberShipsIssue = issues.find((issue) => issue.name === "Members");
    if (memberShipsIssue?.approved) {
        completedTasks.push({
            name: TASK_NAMES.signMemberships,
            status: TASK_STATUS.completed,
            label: t("signMemberships.finished"),
            link: t("signMemberships.link", { clubId }),
        });
    }
    else if (isPreUnapprovedClub || isUnapprovedClub) {
        futureTasks.push({
            name: TASK_NAMES.signMemberships,
            status: TASK_STATUS.future,
            label: t("signMemberships.unfinished"),
            link: t("signMemberships.link", { clubId }),
            description: t("signMemberships.futureDescription"),
        });
    }
    else if (allRegistrationsSigned) {
        pendingApproval.push({
            name: TASK_NAMES.signMemberships,
            status: TASK_STATUS.pendingApproval,
            label: t("signMemberships.pending"),
            link: t("signMemberships.link", { clubId }),
            description: t("signMemberships.pendingDescription"),
        });
    }
    else if (registrations && registrations.length > 0) {
        currentTasks.push({
            name: TASK_NAMES.signMemberships,
            status: TASK_STATUS.current,
            label: t("signMemberships.unfinished"),
            link: t("signMemberships.link", { clubId }),
            description: t("signMemberships.currentDescription", {
                count: unfinishedCount,
            }),
        });
    }
    // Handle constituent meeting task
    if (isStartedCurrentYear || constituentMeetingStatus) {
        if (constituentMeetingStatus?.approved) {
            completedTasks.push({
                name: TASK_NAMES.constituentMeeting,
                status: TASK_STATUS.completed,
                label: t("constituentMeeting.finished"),
                link: t("constituentMeeting.link", { clubId }),
            });
        }
        else if (constituentMeetingStatus?.updated &&
            !constituentMeetingStatus?.approved &&
            (constituentMeetingStatus?.signed ||
                !constituentMeetingStatus?.documentid))
            pendingApproval.push({
                name: TASK_NAMES.constituentMeeting,
                status: TASK_STATUS.pendingApproval,
                label: t("constituentMeeting.pending"),
                link: t("constituentMeeting.link", { clubId }),
                description: t(constituentMeetingStatus.signed
                    ? "constituentMeeting.signedDescription"
                    : "constituentMeeting.uploadedDescription"),
            });
        else if (constituentMeetingStatus?.updated &&
            !constituentMeetingStatus?.approved) {
            currentTasks.push({
                name: TASK_NAMES.signConstituentMeeting,
                status: TASK_STATUS.current,
                label: t("signConstituentMeeting.unfinished"),
                link: t("signConstituentMeeting.link", { clubId }),
                description: t("signConstituentMeeting.description"),
            });
        }
        else if (!isUnapprovedClub) {
            currentTasks.push({
                name: TASK_NAMES.constituentMeeting,
                status: TASK_STATUS.current,
                label: t("constituentMeeting.unfinished"),
                link: t("constituentMeeting.link", { clubId }),
            });
        }
        else {
            futureTasks.push({
                name: TASK_NAMES.constituentMeeting,
                status: TASK_STATUS.future,
                label: t("constituentMeeting.unfinished"),
                link: t("constituentMeeting.link", { clubId }),
                description: t("constituentMeeting.futureDescription"),
            });
        }
    }
    // Handle annual report task
    const annualReportStatus = clubApprovalStatus.find((issue) => issue.referenceid === CheckValuesType.AnnualReport);
    if (annualReportStatus?.approved) {
        completedTasks.push({
            name: TASK_NAMES.annualReport,
            status: TASK_STATUS.completed,
            label: t("annualReport.finished"),
            link: t("annualReport.link", { clubId }),
        });
    }
    else if (annualReportStatus?.updated) {
        pendingApproval.push({
            name: TASK_NAMES.annualReport,
            status: TASK_STATUS.pendingApproval,
            label: t("annualReport.finished"),
            link: t("annualReport.link", { clubId }),
            description: t("annualReport.pendingDescription"),
        });
    }
    else if (annualReportStatus) {
        currentTasks.push({
            name: TASK_NAMES.annualReport,
            status: TASK_STATUS.current,
            label: t("annualReport.unfinished"),
            link: t("annualReport.link", { clubId }),
        });
    }
    // Handle annual meeting task
    const annualMeetingStatus = clubApprovalStatus.find((issue) => issue.referenceid === CheckValuesType.AnnualMeeting);
    if (annualMeetingStatus?.approved) {
        completedTasks.push({
            name: TASK_NAMES.annualMeeting,
            status: TASK_STATUS.completed,
            label: t("annualMeeting.finished"),
            link: t("annualMeeting.link", { clubId }), // TODO: Fix link (ska gå till klubbsidan)
        });
    }
    else if (annualMeetingStatus?.signed) {
        pendingApproval.push({
            name: TASK_NAMES.annualMeeting,
            status: TASK_STATUS.pendingApproval,
            label: t("annualMeeting.finished"),
            link: t("annualMeeting.link", { clubId }),
            description: t("annualMeeting.signedDescription"),
        });
    }
    else if (annualMeetingStatus?.documentid) {
        currentTasks.push({
            name: TASK_NAMES.signAnnualMeeting,
            status: TASK_STATUS.current,
            label: t("signAnnualMeeting.unfinished"),
            link: t("signAnnualMeeting.link", { clubId }),
            description: t("signAnnualMeeting.description"),
        });
    }
    else if (annualMeetingStatus?.updated) {
        pendingApproval.push({
            name: TASK_NAMES.annualMeeting,
            status: TASK_STATUS.pendingApproval,
            label: t("annualMeeting.finished"),
            link: t("annualMeeting.link", { clubId }),
            description: t("annualMeeting.uploadedDescription"),
        });
    }
    else if (annualMeetingStatus) {
        currentTasks.push({
            name: TASK_NAMES.annualMeeting,
            status: TASK_STATUS.current,
            label: t("annualMeeting.unfinished"),
            link: t("annualMeeting.link", { clubId }),
        });
    }
    // Handle order gift task
    if (isStartedCurrentYear || constituentMeetingStatus) {
        if (orderedGiftStatus?.approved) {
            completedTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.completed,
                label: t("orderGift.finished"),
                link: t("orderGift.link", { clubId }),
            });
        }
        else if (constituentMeetingStatus?.approved &&
            memberShipsIssue?.approved) {
            currentTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.current,
                label: t("orderGift.unfinished"),
                link: t("orderGift.link", { clubId }),
            });
        }
        else {
            futureTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.future,
                label: t("orderGift.unfinished"),
                link: t("orderGift.link", { clubId }),
            });
        }
    }
    else {
        if (orderedGiftStatus?.approved) {
            completedTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.completed,
                label: t("orderGift.finished"),
                link: t("orderGift.link", { clubId }),
            });
        }
        else if (annualMeetingStatus?.approved &&
            annualReportStatus?.approved &&
            memberShipsIssue?.approved) {
            currentTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.current,
                label: t("orderGift.unfinished"),
                link: t("orderGift.link", { clubId }),
            });
        }
        else {
            futureTasks.push({
                name: TASK_NAMES.orderGift,
                status: TASK_STATUS.future,
                label: t("orderGift.unfinished"),
                link: t("orderGift.link", { clubId }),
            });
        }
    }
    // Handle class list issue
    const classListIssue = issues.find((issue) => issue.name === "noClassSize");
    if (classListIssue) {
        if (classListIssue.approved) {
            completedTasks.push({
                name: TASK_NAMES.classList,
                status: TASK_STATUS.completed,
                label: t("classList.finished"),
                link: t("classList.link", { clubId }),
            });
        }
        else {
            currentTasks.push({
                name: TASK_NAMES.classList,
                status: TASK_STATUS.current,
                label: t("classList.unfinished"),
                link: t("classList.link", { clubId }),
            });
        }
    }
    // Handle not enough players in team issue
    const notEnoughPlayersIssue = issues.find((issue) => issue.name === "hasNotEnoughPlayers");
    if (notEnoughPlayersIssue) {
        const label = classListIssue && !classListIssue?.approved
            ? TASK_NAMES.addPlayersNoClassSize
            : TASK_NAMES.addPlayers;
        if (notEnoughPlayersIssue.approved) {
            completedTasks.push({
                name: TASK_NAMES.addPlayersNoClassSize,
                status: TASK_STATUS.completed,
                label: t("addPlayersNoClassSize.finished", {
                    count: notEnoughPlayersIssue.count,
                    preferredCount: notEnoughPlayersIssue.preferredCount,
                }),
                link: t("addPlayersNoClassSize.link", { clubId }),
            });
        }
        else if (!isUnapprovedClub && someRegistrationsSigned) {
            currentTasks.push({
                name: label,
                status: TASK_STATUS.current,
                label: t(`${label}.unfinished`, {
                    count: notEnoughPlayersIssue.count,
                    preferredCount: notEnoughPlayersIssue.preferredCount,
                }),
                link: t(`${label}.link`, { clubId }),
            });
        }
        else {
            futureTasks.push({
                name: label,
                status: TASK_STATUS.future,
                label: t(`${label}.unfinished`, {
                    count: notEnoughPlayersIssue.count,
                    preferredCount: notEnoughPlayersIssue.preferredCount,
                }),
                link: t(`${label}.link`, { clubId }),
                description: t(isUnapprovedClub
                    ? "addPlayers.clubPendingDescription"
                    : "addPlayers.signedMembershipsMissingDescription"),
            });
        }
    }
    // Handle team player memberships approved issue
    const allPlayersOfficialMembersIssue = issues.find((issue) => issue.name === "allPlayersAreNotOfficialMembers");
    if (allPlayersOfficialMembersIssue && notEnoughPlayersIssue?.approved) {
        if (allPlayersOfficialMembersIssue.approved) {
            completedTasks.push({
                name: TASK_NAMES.teamPlayerMembershipsApproved,
                status: TASK_STATUS.completed,
                label: t("teamPlayerMembershipsApproved.finished"),
                link: t("teamPlayerMembershipsApproved.link", { clubId }),
            });
        }
        else if (notEnoughPlayersIssue?.approved) {
            pendingApproval.push({
                name: TASK_NAMES.teamPlayerMembershipsApproved,
                status: TASK_STATUS.pendingApproval,
                label: t("teamPlayerMembershipsApproved.unfinished", {
                    count: allPlayersOfficialMembersIssue.count,
                    preferredCount: allPlayersOfficialMembersIssue.preferredCount,
                }),
                link: t("teamPlayerMembershipsApproved.link", { clubId }),
            });
        }
    }
    // Handle team player memberships signed issue
    const teamPlayerMembershipsSignedIssue = issues.find((issue) => issue.name === "allPlayersHaveNotSignedMemberships");
    if (teamPlayerMembershipsSignedIssue &&
        !teamPlayerMembershipsSignedIssue?.approved &&
        notEnoughPlayersIssue?.approved &&
        !allPlayersOfficialMembersIssue?.approved) {
        currentTasks.push({
            name: TASK_NAMES.teamPlayerMembershipsSigned,
            status: TASK_STATUS.current,
            label: t("teamPlayerMembershipsSigned.unfinished", {
                count: teamPlayerMembershipsSignedIssue.count,
                preferredCount: teamPlayerMembershipsSignedIssue.preferredCount,
            }),
            link: t("teamPlayerMembershipsSigned.link", { clubId }),
        });
    }
    // Handle break weeks issue
    const breakWeeksIssue = issues.find((issue) => issue.name === "breakWeeksAreMissing");
    if (breakWeeksIssue) {
        if (breakWeeksIssue.approved) {
            completedTasks.push({
                name: TASK_NAMES.breakWeeks,
                status: TASK_STATUS.completed,
                label: t("breakWeeks.finished"),
                link: t("breakWeeks.link", { clubId }),
            });
        }
        else {
            currentTasks.push({
                name: TASK_NAMES.breakWeeks,
                status: TASK_STATUS.current,
                label: t("breakWeeks.unfinished"),
                link: t("breakWeeks.link", { clubId }),
            });
        }
    }
    // Handle gold gift task
    const currentYear = new Date().getFullYear();
    const goldStatusEntry = clubStatus?.find((s) => s.status === 1 && s.year === currentYear);
    if (goldStatusEntry &&
        orderedGiftStatus?.approved &&
        goldStatusEntry.orderedGift !== 1) {
        currentTasks.push({
            name: TASK_NAMES.orderGoldGift,
            status: TASK_STATUS.current,
            label: t("orderGoldGift.unfinished"),
            link: t("orderGoldGift.link", { clubId }),
        });
    }
    return {
        completedTasks,
        currentTasks,
        pendingApproval,
        futureTasks,
    };
};
//# sourceMappingURL=getTasks.js.map